import { IncentivesMarketPlanContext } from 'modules/incentivesMarket/types/IncentivesMarketBeneficiaryContext';

import { SellPlanBreakdownRow } from './distributeSellUnitsByPlan';
import { SellPlan } from '../types/SellUnitsSelection';
import { computeSellTotals, planNet } from './sellUnitsCalculations';

type BuildSellBreakdownFromSelectionArgs = {
  plans: SellPlan[];
  sellerPlans: IncentivesMarketPlanContext[];
  unitsByPlan: Record<string, number>;
  retentionPercent?: number;
};

export type BuildSellBreakdownFromSelectionResult = {
  rows: SellPlanBreakdownRow[];
  total: number;
  totalRemaining: number;
};

export const buildSellBreakdownFromSelection = ({
  plans,
  sellerPlans,
  unitsByPlan,
  retentionPercent = 0,
}: BuildSellBreakdownFromSelectionArgs): BuildSellBreakdownFromSelectionResult => {
  const rows: SellPlanBreakdownRow[] = plans.map((plan, index) => {
    const sellerPlan = sellerPlans[index];
    const unitsSold = Math.max(0, unitsByPlan[plan.id] || 0);
    const availableUnits = plan.holdings;

    return {
      planId: sellerPlan?.planId ?? plan.planId ?? null,
      beneficiaryId: sellerPlan?.beneficiaryId ?? plan.beneficiaryId,
      planName: plan.name,
      availableUnits,
      unitsSold,
      remainingUnits: availableUnits - unitsSold,
      sharePrice: plan.exercisePrice,
      sellingPrice: plan.salePrice,
      retentionPercent,
      result: planNet(plan, unitsSold),
    };
  });

  const { net: total } = computeSellTotals(plans, unitsByPlan);
  const totalRemaining = rows.reduce(
    (sum, row) => sum + row.remainingUnits,
    0
  );

  return { rows, total, totalRemaining };
};
